const createNotification = (label, value) => {
    return {label: label, value: value};
};

const permitApplicationFieldsUtil = {
    checkElements(elements, primaryAttribute, secondaryAttribute = null) {
        return (
            elements?.some(element => {
                const primaryCondition = element[primaryAttribute] === true;

                if (!secondaryAttribute) return primaryCondition;

                return primaryCondition && element[secondaryAttribute] === true;
            }) ?? false
        );
    },

    checkFeesInTrees(trees) {
        if (trees)
            return trees.every(tree => {
                if (
                    (tree.felling && !tree.felling_fee) ||
                    (tree.cutting && !tree.cutting_fee)
                ) {
                    return false;
                }
                return true;
            });
    },

    checkFeesInMaterials(materials) {
        return materials?.every(material => material.fee || material.fee === 0);
    },

    createNotifications(fieldsArray) {
        return fieldsArray.map(([label, value]) => createNotification(label, value));
    },
};

export default permitApplicationFieldsUtil;
